export const giftOverlay = (theme) => ({
    giftOverlay: {},
    appBar: {
        position: "relative",
        padding: "0 8px 0 8px !important",
        background: "white",
        borderBottom: `1px solid ${theme.customPalette.neutralGy05}`,
        [theme.breakpoints.down("sm")]: {
            borderTop: `27px solid ${theme.customPalette.neutralGy05}`,
        },
    },
    body: {
        padding: theme.spacing(0, 4, 4, 4),
    },
    icon: {
        height: 24,
        width: 24,
    },
    title: {
        marginLeft: theme.spacing(2),
        flex: 1,
    },
    image: {
        height: 380,
        width: 400,
        display: "block",
        margin: "auto",
        [theme.breakpoints.down("xs")]: {
            width: 300,
        },
    },
    name: {},
    descriptio: {},
});
